import { referralApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useReferralsTotalQuery = () => {
  return useQuery([QUERIES.REFERRALS_TOTAL], () => referralApi.getTotal());
};
